import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ChangePasswordForm from '../components/Users/ChangePasswordForm';
import { makeStyles } from '@material-ui/core';
import { updateUser } from './../actions/user'
import { createCode, changeCode, changeStatusUser } from './../actions/codes'
import { changeState } from './../actions/loginUser'
import { history } from '../helpers/history';
import DialogOTP from '../components/Complements/DialogOTP';
import { sendMobile } from '../functions/mobile';
import { filterArrayEqual } from '../functions/arrays';
import LoadingScreen from '../components/Complements/LoadingScreen';
//import { sendLogs } from '../functions/function-logs';
import { validateIp } from '../functions/store';
import { checkNumber, checkPasswordLength, checkSpecialCharacters, checkUppercase, checkLowercase, passwordProgressControl } from '../functions/validators';
import {encrypt} from './../functions/mobile';
import { feathersCreateData } from '../services';

class PasswordChangeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordNew: '',
            passwordRepeat: '',
            passworProvisional: '',
            openDialogOTP: false,
            otp: '',
            newPass: '',
            oldPassword: '',
            initialTime: Date.now(),
            seq: '',
            contAttempts : 0,
            loading: false,
            numberValid: false,
            uppercaseValid: false,
            lowercaseValid:false,
            specialCharValid: false,
            charNumberValid: false,
            progress: 0
        }
    }
    // functions

    handleChangeStatusUser = () => {

        this.props.changeStatusUser({emited : "NAVCHANGESTATUS", iduser : this.props.user.id}).then(
            response => {
                // console.log(response)
            }
        ).catch(
            error => {
                //console.log(error)
            }
        )
    }
    handleChangePasswordNew = (event) => {
        // console.log('LA DATA ', event.target.value)
        const {value} = event.target
        const numberValid = checkNumber(value)
        const uppercaseValid = checkUppercase(value)
        const lowercaseValid = checkLowercase(value)
        const specialCharValid = checkSpecialCharacters(value)
        const charNumberValid = checkPasswordLength(value, 8)
        this.setState({ passwordNew : value, numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid })
        this.setState({ progress: passwordProgressControl({numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid }, 5) })
    }

    handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            // console.log("VALUE OTP: ", valueinput)
            this.receiveOTP({data : valueinput.target.value.toString()});
        }

    }


    receiveOTP = async(otp) => {
        
        try {

            this.setState({loading: true})

            const { devices } = this.props;

            const sendData = encrypt(JSON.stringify({
                ip : devices.ip,
                mac : devices.mac,
                device : devices.device,
                type : 10,
                inputOtp : otp.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;
            
            if (error === false) {
                
                this.handleCloseDialogOTP()
                const {getDeviceData, updateIpDevice, devices } = this.props
                const { ip, mac, device } = devices
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                const { seq, newPass, oldPassword } = this.state
                const { parameters } = this.props
                let number_day_for_change_password = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'NumberDaysChangePassword')[0].value : 365
                // console.log(id)
                const sendData = encrypt(JSON.stringify({emited: 'NAVCHANGE', id: seq, newPass, oldPassword, mac, device, ip: ipSend, numberdays : number_day_for_change_password, type : 10, otp : otp.data}))
                this.props.changeCode({ sendData }).then(r =>{
                    // console.log('lo que me devuelve ', r.payload)
                    if(r.payload){
                        this.props.handleOpenSnack(r.payload.alert, r.payload.type)
    
                        let send = {
                            type: 'action',
                            action: 'updatePassword',
                            data: this.state.newPass
                        }
                        this.props.changeState(1)
                        sendMobile(JSON.stringify(send))
                        this.setState({loading: false})
                        if(r.payload.type === "success") { history.push('/') }
                    }
                }).catch( error => {
                    this.props.handleOpenSnack('Ha ocurrido un error al cambiar su contraseña. Por favor intente nuevamente.', 'error')
                    //console.log(error)
                    this.setState({loading: false})
                })
                 // history.push('/')
                 // this.props.handleOpenSnack('Pago realizado', 'success')
            } else {
                this.props.handleOpenSnack(message, type)
                if(viewDialogOtp === false){
                    this.handleCloseDialogOTP()
                }
                this.setState({loading: false})
            } 

        } catch (error) {
            this.setState({loading: false})
            this.props.handleOpenSnack('Ha ocurrido un error al cambiar su contraseña. Por favor intente nuevamente.', 'error')
        }
 
     }
    // handle kyuin123
    handleSubmit = async(values) => {
        try {
            const {getDeviceData, updateIpDevice, devices } = this.props
            const { ip, mac, device } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            this.setState({loading: true})

            const sendData = encrypt(JSON.stringify({ type: 10, emited: 'NAV', device, ip: ipSend, mac }))
            this.props.createCode({ sendData }).then( res => {
                const { alert, type } = res.payload

                if(type === "success"){
                    this.setState({ openDialogOTP: true, newPass: values.passwordNew, oldPassword : values.oldPassword, loading: false })
                }else{
                    this.props.handleOpenSnack(alert, type)
                }
                
            }).catch( error => {
                this.setState({loading: false})
                this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
            })
        } catch (error) {
            this.setState({loading: false})
            //console.log('error submit', error)
            this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
        } 
        
    }
        
    handleCloseDialogOTP = () => {
      this.setState({ openDialogOTP: false })
    };

    handleChangeOldPassword = (event) => {

        const { value } = event.target

        //console.log("value old password: ", value)

        this.setState({
            oldPassword : value
        })
    }

    handleChangeRepeatPassword = (event) => {

        const { value } = event.target

        //console.log("value repeat password: ", value)

        this.setState({
            passwordRepeat : value
        })
    }
    // renders
    renderBody = () => {
        const useStyles = makeStyles(theme => ({
            textField: {
                width: 200,
            },
            margin: {
                margin: theme.spacing(1),
            },
        }));
        return  <div>
                    <ChangePasswordForm 
                        {...this.state}
                        classes = { useStyles }
                        onSubmit = { this.handleSubmit }
                        handleChangePasswordNew = { this.handleChangePasswordNew }
                        handleChangeOldPassword = { this.handleChangeOldPassword }
                        handleChangeRepeatPassword = { this.handleChangeRepeatPassword }
                    />
                    <DialogOTP
                        {...this.state} 
                        showQR = {false}
                        onCloseDialogOTP = { this.handleCloseDialogOTP }
                        onKeyPress = { this.handleChangeInputOtp }
                        OTPSubmit = { this.receiveOTP }
                        initialTime = { Date.now()}
                    />
                </div>
    }
    render() {
        const {loading} = this.state
        return (
            <div>
                <LoadingScreen open={loading} />
                <Dashboard
                    title= ""
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        );
    }
}

PasswordChangeContainer.propTypes = {

};

export default withRouter(connect(null, { updateUser, createCode, changeCode, changeState, changeStatusUser } )(PasswordChangeContainer))
// export default PasswordChangeContainer;